export const STORAGE_KEYS = {
    authToken:          "auth_token",
    authUser:           "auth_user",
    bookingData:        "bookingData",
    enquirySubmittedAt: "tempula_enquiry_submitted_at",
} as const

type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS]

function getString(key: StorageKey): string | null {
    return sessionStorage.getItem(key)
}

function setString(key: StorageKey, value: string): void {
    sessionStorage.setItem(key, value)
}

function remove(key: StorageKey): void {
    sessionStorage.removeItem(key)
}

function getJson<T>(key: StorageKey): T | null {
    const raw = sessionStorage.getItem(key)
    if (!raw) return null
    try { return JSON.parse(raw) as T } catch { return null }
}

function setJson<T>(key: StorageKey, value: T): void {
    sessionStorage.setItem(key, JSON.stringify(value))
}

export const storageService = { getString, setString, remove, getJson, setJson }
